import {ReactNode, useState} from "react";
import {css, cx} from "@panda/css";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {IAuthModalVariant} from "../state/auth_modal_slice";
import {AuthActionType} from "../types/AuthActionType";
import {ExtendedRegisterCard} from "./auth_card/ExtendedRegisterCard";
import {ExtendedRegisterReportCard} from "./auth_card/ExtendedRegisterReportCard";
import {HiddenPriceRegisterCard} from "./auth_card/HiddenPriceRegisterCard";
import {LoginCard} from "./auth_card/LoginCard";
import {RegisterCard} from "./auth_card/RegisterCard";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    modalTitle: ReactNode | string;
    modalDescription?: ReactNode | string;
    gtmEventData?: () => void;
    variant?: IAuthModalVariant;
    className?: string;
    wrapperClassName?: string;
}

export const AuthCard = (props: IProps) => {
    const {variant, modalTitle, onAuthSuccess, userSource, className, gtmEventData, gtmSourceSection, modalDescription, wrapperClassName} = props;

    const [register, setRegister] = useState(true);

    const onToggleAuthForm = () => setRegister((prev) => !prev);

    const RegisterComponent = {
        extended: ExtendedRegisterCard,
        download_report: ExtendedRegisterReportCard,
        hidden_prices_variant_b: HiddenPriceRegisterCard,
        default: RegisterCard
    }[variant ?? "default"];

    return (
        <div className={cx(authCard, className)}>
            {register ? (
                <RegisterComponent
                    onAuthSuccess={onAuthSuccess}
                    onSwitchToLogin={onToggleAuthForm}
                    userSource={userSource}
                    gtmSourceSection={gtmSourceSection}
                    title={modalTitle}
                    description={modalDescription}
                    gtmEventData={gtmEventData}
                    wrapperClassName={wrapperClassName}
                />
            ) : (
                <LoginCard
                    onAuthSuccess={onAuthSuccess}
                    onSwitchToRegister={onToggleAuthForm}
                    userSource={userSource}
                    gtmSourceSection={gtmSourceSection}
                    wrapperClassName={wrapperClassName}
                />
            )}
        </div>
    );
};

const authCard = css({
    width: "100%",

    "@media (min-width: 768px)": {
        width: "456px"
    }
});
import {ReactNode, useState} from "react";
import {css, cx} from "@panda/css";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {IAuthModalVariant} from "../state/auth_modal_slice";
import {AuthActionType} from "../types/AuthActionType";
import {ExtendedRegisterCard} from "./auth_card/ExtendedRegisterCard";
import {ExtendedRegisterReportCard} from "./auth_card/ExtendedRegisterReportCard";
import {HiddenPriceRegisterCard} from "./auth_card/HiddenPriceRegisterCard";
import {LoginCard} from "./auth_card/LoginCard";
import {RegisterCard} from "./auth_card/RegisterCard";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    modalTitle: ReactNode | string;
    modalDescription?: ReactNode | string;
    gtmEventData?: () => void;
    variant?: IAuthModalVariant;
    className?: string;
    wrapperClassName?: string;
}

export const AuthCard = (props: IProps) => {
    const {variant, modalTitle, onAuthSuccess, userSource, className, gtmEventData, gtmSourceSection, modalDescription, wrapperClassName} = props;

    const [register, setRegister] = useState(true);

    const onToggleAuthForm = () => setRegister((prev) => !prev);

    const RegisterComponent = {
        extended: ExtendedRegisterCard,
        download_report: ExtendedRegisterReportCard,
        hidden_prices_variant_b: HiddenPriceRegisterCard,
        default: RegisterCard
    }[variant ?? "default"];

    return (
        <div className={cx(authCard, className)}>
            {register ? (
                <RegisterComponent
                    onAuthSuccess={onAuthSuccess}
                    onSwitchToLogin={onToggleAuthForm}
                    userSource={userSource}
                    gtmSourceSection={gtmSourceSection}
                    title={modalTitle}
                    description={modalDescription}
                    gtmEventData={gtmEventData}
                    wrapperClassName={wrapperClassName}
                />
            ) : (
                <LoginCard
                    onAuthSuccess={onAuthSuccess}
                    onSwitchToRegister={onToggleAuthForm}
                    userSource={userSource}
                    gtmSourceSection={gtmSourceSection}
                    wrapperClassName={wrapperClassName}
                />
            )}
        </div>
    );
};

const authCard = css({
    width: "100%",

    "@media (min-width: 768px)": {
        width: "456px"
    }
});
